export const isEmpty = (any) => {
  if (any === '') { return true }
  if (any === null) { return true }
  if (any === undefined) { return true }
  if (Array.isArray(any) && any.length === 0) { return true }
  if (Object.keys(any).length === 0 && any.constructor === Object) { return true }

  return false
}
